import { Injectable } from '@angular/core';
import { ApiHttpService } from './api.http.service';
import { HttpClient } from '@angular/common/http';
import { APIEndPoints } from '../utils/api-endpoint';

@Injectable({
    providedIn: 'root'
})

export class FileNotificationService {
    constructor(private _apiService: ApiHttpService, private http: HttpClient) { }

    IsFileViewed() {
        return this._apiService.get(APIEndPoints.Professional + '/IsFileView').pipe();
    }

    GetFileNotifications(data) {
        return this._apiService.post(APIEndPoints.Professional + '/Notifications', data).pipe();
    }
    FileViewed(id) {
        return this._apiService.post(APIEndPoints.Professional + '/FileViewed', id).pipe();
    }

}
